import React, {useEffect, useState} from 'react';
import {Stack} from 'react-bootstrap';
import {NavLink, useLocation} from 'react-router-dom';
import './sidebar.component.scss';

export type MenuItem = { icon: string; name: string; to: string; children?: { name: string; to: string }[]; expend?: boolean };

type Props = { menuItems: MenuItem[], onCollapsed: (state: boolean) => void };
type States = { collapsed: boolean };
export const Sidebar: React.FunctionComponent<Props> = ({menuItems, onCollapsed}) => {
    const location = useLocation();
    const [states, setStates] = useState({collapsed: false} as States);

    useEffect(() => {
        const currentPath = location.pathname;
        menuItems.forEach((item) => {
            if (item.children && currentPath.indexOf(item.to) === 0) {
                item.expend = true;
            }
        });
    }, []);


    const handleMouseEnterLeave = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (states.collapsed) {
            const $el: HTMLElement = event.currentTarget;
            $el.classList[event.type === 'mouseover' ? 'remove' : 'add']('sl-sidebar--collapsed');
        }
    }

    const handleCollapseExpand = () => {
        const collapsed = !states.collapsed;
        setStates({...states, collapsed});
        onCollapsed(collapsed);
    }

    const collapseExpandLinkBranch = (event: React.MouseEvent<HTMLAnchorElement>) => {
        const $branch = (event.target as HTMLDivElement).closest('.sl-sidebar__branch');
        const isExpended = $branch.classList.contains('sl-sidebar__branch--expended');
        $branch.classList[isExpended ? 'remove' : 'add']('sl-sidebar__branch--expended');
        event.preventDefault();
    }


    return (
        <Stack
            onMouseOver={handleMouseEnterLeave}
            onMouseOut={handleMouseEnterLeave}
            className={`sl-sidebar min-vh-100 bg-dark px-3 py-2 text-white ${states.collapsed ? 'sl-sidebar--floating' : ''}`}
        >
            <Stack className="sl-sidebar__head justify-content-between mt-2 mb-3 pb-3 border-bottom border-secondary"
                   direction="horizontal">
                <Stack direction="horizontal" className="sl-sidebar__logo justify-content-between">
                    <img src="/logo_28x24.png"/>
                    <span className="sl-sidebar__logo-text">FINEKRAN</span>
                </Stack>
                <i
                    className={`sl-sidebar__toggle-btn bi bi-list`}
                    onClick={handleCollapseExpand}
                ></i>
            </Stack>
            <Stack gap={2}>
                {menuItems.map((item) => {
                    const itemIcon = <i className={`bi bi-${item.icon}`}></i>;
                    if (item.children) {
                        return (
                            <div className={`sl-sidebar__branch ${item.expend ? 'sl-sidebar__branch--expended' : ''}`}
                                 key={item.to}>
                                <NavLink to={item.to} className="sl-sidebar__link" onClick={collapseExpandLinkBranch}>
                                    {itemIcon}
                                    <span className="sl-sidebar__link-text">{item.name}</span>
                                    <i className="sl-sidebar__branch-status bi"></i>
                                </NavLink>
                                <ul className="sl-sidebar__child-links">
                                    {item.children.map((child) => (
                                        <li key={child.to}>
                                            <NavLink to={child.to} className="sl-sidebar__link">
                                                {child.name}
                                            </NavLink>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        );
                    } else {
                        return (
                            <NavLink to={item.to} className="sl-sidebar__link" key={item.to}>
                                {itemIcon}
                                <span className="sl-sidebar__link-text">{item.name}</span>
                            </NavLink>
                        );
                    }
                })}
            </Stack>
            <div className="sl-sidebar__social d-flex border-top border-secondary pt-2 justify-content-center">
                <div className="d-flex w-50 justify-content-between">
                    <a className="text-light" target="_blank" href="https://twitter.com/finekran">
                        <i className="bi bi-twitter"></i>
                    </a>
                    <a className="text-light" target="_blank" href="https://www.instagram.com/finekran/">
                        <i className="bi bi-instagram"></i>
                    </a>
                    <a className="text-light" target="_blank" href="https://t.me/finekran">
                        <i className="bi bi-telegram"></i>
                    </a>
                </div>
            </div>
        </Stack>
    );

}